export default "__VITE_ASSET__19BNhaoY__"